type TFBEvents = 'AddToCart' | 'Purchase' | 'ViewContent';

declare global {
    interface Window {
        fbq?: (action: 'track', event: TFBEvents, data: object) => void;
    }
}

export const trackFBPixelEvent = (eventName: TFBEvents, data: object) => {
    if (window?.fbq) {
        window.fbq('track', eventName, data);
    }
};
